import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import {
  ApDomainList_Url,
  ApBusinessTypeList_Url,
} from "../../../provider/ServiceUrl";
import { Autocomplete, TextField, Grid } from "@mui/material";
import store from "../../../redux/store";
import MaterialTable from "material-table";
import PtsButton from "../../givBee/buttons/PtsButton";
import UiUtils from "../../../provider/UiUtils";
import Utils from "../../../provider/Utils";

class BusinessTypeList extends Component {
  title = "Buisness Type List";
  breadCrumb = [{ pageid: "", uiname: "Business Type List" }];
  header = store.getState().adminHeader.adminHeader;

  constructor(props) {
    super(props);

    let businessDomain = null;
    let businessType = null;

    if (props.state) {
      businessDomain = props.state.businessDomain;
    }
    if (props.state?.businessType) {
      businessType = props.state.businessType;
    }

    this.state = {
      initialPage: 0,
      pageSize: 10,
      isPaging: false,
      businessDomain: businessDomain,
      businessType: businessType,
      businessDomainList: [],
      businessTypeList: [],
      render: false,
    };
  }

  componentDidMount() {
    this.getBusinessDomainList();
  }

  getBusinessTypeList = (businessDomain) => {
    const postObject = {
      header: this.header,
      businessDomain: {
        id: businessDomain.id,
      },
    };
    AdminFetchServerData.callPostService(
      ApBusinessTypeList_Url,
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let businessTypeList = output.data.businessTypeList;
        this.setState({
          businessTypeList: businessTypeList,
          render: true,
        });
      }
    });
  };

  handleBusinessDomainChange(selectedDomain) {
    this.getBusinessTypeList(selectedDomain);
    this.setState({
      businessDomain: selectedDomain,
    });
  }

  getBusinessDomainList() {
    const postObject = {
      header: this.header,
    };
    AdminFetchServerData.callPostService(ApDomainList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let businessDomainList = output.data.businessDomainList;
          let businessDomain =
            this.state.businessDomain !== null
              ? this.state.businessDomain
              : Utils.getArrayElement(businessDomainList, 0);

          this.setState({
            businessDomainList: businessDomainList,
            businessDomain: businessDomain,
          });
          this.getBusinessTypeList(this.state.businessDomain);
        } else {
        }
      }
    );
  }

  handleRowClick = (rowData) => {
    this.props.navigate(`/useCaseList`, {
      state: {
        action: "view",
        businessType: rowData,
        businessDomain: this.state.businessDomain,
      },
    });
  };

  addBusinessType = () => {
    this.props.navigate(`/businessType`, {
      state: {
        action: "create",
        businessDomain: this.state.businessDomain,
      },
    });
  };

  render() {
    if (this.state.render === false) {
      return <div />;
    }

    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          navigate={this.props.navigate}
          name={this.title}
        />
        <label className="mb-2">Business Domain:</label>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8} md={4}>
            <Autocomplete
              fullWidth
              disableClearable
              autoComplete="off"
              options={this.state.businessDomainList}
              value={this.state.businessDomain}
              getOptionLabel={(option) => option.name}
              defaultValue={this.state.businessDomain}
              onChange={(event, value) => {
                this.handleBusinessDomainChange(value);
              }}
              inputprops={{
                style: { textTransform: "capitalize" },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Business domain"
                  variant="outlined"
                  size="small"
                  style={{ background: "#fff" }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <MaterialTable
              title=""
              onRowClick={(event, rowData) => {
                this.handleRowClick(rowData);
                event.stopPropagation();
              }}
              icons={UiUtils.getMaterialTableIcons()}
              localization={{
                body: {
                  emptyDataSourceMessage: (
                    <h5 className="dataNotAvailable">No data found.</h5>
                  ),
                },
              }}
              columns={[
                {
                  title: "Business Type",
                  field: "name",
                  width: "80%",
                  align: "left",
                  cellStyle: {
                    width: "80%",
                  },
                },
              ]}
              data={this.state.businessTypeList}
              options={{
                sorting: true,
                actionsColumnIndex: -1,
                initialPage: this.state.initialPage,
                pageSize: this.state.pageSize,
                pageSizeOptions: [5, 10, 20, 50, 100],
                paging: this.state.isPaging,
                headerStyle: {
                  backgroundColor: "#37517e",
                  fontWeight: "bold",
                  color: "#ffff",
                  align: "left",
                },
                rowStyle: (rowData) => ({
                  backgroundColor:
                    rowData.id === this.state.businessType?.id ? "#FEF5E7" : "",
                  height: "3em",
                  textTransform: "capitalize",
                }),
              }}
              onChangePage={(page, pageSize) => {
                this.handleMaterialTablePageChange(page, pageSize);
              }}
              actions={[
                {
                  icon: () =>
                    true && (
                      <PtsButton btnName="Add Business Type" type="submit" />
                    ),
                  isFreeAction: true,
                  onClick: (event) => this.addBusinessType(),
                },
              ]}
            />
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withRouter(BusinessTypeList);
